// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid {
  min-height: 100%;
  background-size: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/publications/publications.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sBAAA;AACF","sourcesContent":[".container-fluid {\r\n  min-height: 100%;\r\n  background-size: cover;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
